import { EcommerceSectionNamespace } from '@services/ecommerceService';

interface IModifyCartEvent {
  action: EcommerceSectionNamespace.EEcommerceCartActions;
  quantity: number;
}

export const createModifyCartEvent = (productCount: number, quantity: number): IModifyCartEvent =>
  productCount <= quantity
    ? { action: EcommerceSectionNamespace.EEcommerceCartActions.ADD, quantity: quantity - productCount }
    : { action: EcommerceSectionNamespace.EEcommerceCartActions.REMOVE, quantity: productCount - quantity };
